import { render, staticRenderFns } from "./VehicleCapacityModal.vue?vue&type=template&id=707ba142&scoped=true"
import script from "./VehicleCapacityModal.vue?vue&type=script&lang=js"
export * from "./VehicleCapacityModal.vue?vue&type=script&lang=js"
import style0 from "./VehicleCapacityModal.vue?vue&type=style&index=0&id=707ba142&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707ba142",
  null
  
)

export default component.exports